/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Quick_Heron_DiveInputs */

const en_soft_quick_heron_dive = /** @type {(inputs: Soft_Quick_Heron_DiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request rejected`)
};

const de_soft_quick_heron_dive = /** @type {(inputs: Soft_Quick_Heron_DiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfrage abgelehnt`)
};

/**
* | output |
* | --- |
* | "Request rejected" |
*
* @param {Soft_Quick_Heron_DiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_quick_heron_dive = /** @type {((inputs?: Soft_Quick_Heron_DiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Quick_Heron_DiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_quick_heron_dive(inputs)
	return de_soft_quick_heron_dive(inputs)
});